import React from 'react';
import { assest } from '../Assest/Assest';

const ContactUs = () => {
  return (
    <div style={styles.contactContainer}>
      <div style={styles.contactContent}>
        <div style={styles.contactImageWrapper}>
          <img 
            src={assest.contentus} // Replace with actual image path
            alt="Contact Us"
            style={styles.contactImage}
          />
        </div>
        <div style={styles.contactDetails}>
          <h1 style={styles.title}>Get In Touch</h1>
          <p style={styles.subtitle}>
            Dentin Dental Care & Implant Center <br />
            First in-house CBCT X-ray clinic in Erode
          </p>
          <div style={styles.contactInfo}>
            <h2 style={styles.phone}>Call us: <span>9698704907</span></h2>
            <a 
              href="https://wa.me/+919698704907" 
              style={styles.whatsapp}
            >
              Message Us on WhatsApp
            </a>
            <p style={styles.location}>
              Visit us: <span>30, Pariyur Rd, near Mettuvalavu, Opp. to Sakthi Sugar Office, Bustop, <br />
              Gobichettipalayam, Tamil Nadu 638476</span>
            </p>
          </div>
        </div>
      </div>

      {/* Google Map */}
      <div style={styles.mapContainer}>
      <iframe
              width="100%"
              height="100%"
              frameBorder="0"
              scrolling="no"
              marginHeight="0"
              marginWidth="0"
              src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=Dentin%20Dental%20Care%20-%20An%20Invisalign%20Studio%20&amp%20Implant%20Centre%20(CBCT%20X-Ray%20centre)&amp;t=p&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
              title="Dentin Dental Care Map"
              style={{
                transition: "transform 0.3s ease-in-out",
              }}
            ></iframe>
      </div>
    </div>
  );
};

const styles = {
  contactContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#CADCFC',
    padding: '20px',
    boxSizing: 'border-box',
  },
  contactContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '800px',
    width: '100%',
    backgroundColor: '#fff',
    padding: '30px',
    borderRadius: '10px',
    boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.1)',
    marginBottom: '30px',
    textAlign: 'center',
  },
  contactImageWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '20px',
  },
  contactImage: {
    maxWidth: '90%',
    height: 'auto',
    borderRadius: '8px',
    objectFit: 'cover',
  },
  contactDetails: {
    width: '100%',
  },
  title: {
    fontSize: '26px',
    color: '#00246B',
    marginBottom: '10px',
  },
  subtitle: {
    fontSize: '15px',
    color: '#555',
    marginBottom: '15px',
  },
  contactInfo: {
    fontSize: '15px',
    color: '#00246B',
  },
  phone: {
    fontSize: '16px',
    color: '#00246B',
    marginBottom: '10px',
  },
  whatsapp: {
    display: 'block',
    textDecoration: 'none',
    backgroundColor: '#00246B',
    color: '#CADCFC',
    padding: '12px',
    borderRadius: '5px',
    fontSize: '15px',
    textAlign: 'center',
    width: '100%',
    marginBottom: '15px',
  },
  location: {
    fontSize: '15px',
    color: '#00246B',
  },
  mapContainer: {
    width: '100%',
    height: '400px',
    borderRadius: '10px',
    overflow: 'hidden',
    marginTop: '20px',
    boxShadow: '0px -4px 15px rgba(0, 0, 0, 0.1)',
  },
  mapIframe: {
    border: '0',
    borderRadius: '10px',
  },
};

export default ContactUs;
